import { render, staticRenderFns } from "./ResidentialTemplates.vue?vue&type=template&id=63ee4688"
import script from "./ResidentialTemplates.vue?vue&type=script&lang=js"
export * from "./ResidentialTemplates.vue?vue&type=script&lang=js"
import style0 from "./ResidentialTemplates.vue?vue&type=style&index=0&id=63ee4688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports